// --------------------------------------------------------------------------
// Components of landing page including their logical connections.
// --------------------------------------------------------------------------

import { useNavigate } from 'react-router-dom';
import { Box, Flex, Image, Heading, Button, useTheme, Text } from "@chakra-ui/react";
import logo_emi from "./assets/emi_inverted.png";
import "./styles.css";


// --- BACKGROUND ---
function Background() {
  return(
    <Box className="background"></Box>
  );
};

const Copyright = () => {
  const theme = useTheme();
  
  return (
    <Box
      position="fixed"
      bottom="10px"
      right="10px"
      zIndex={0}>
      <Text
        color="black"
        fontSize={theme.fontSize.info}>
      </Text>
    </Box>
  );
};

// --- HEADER ---
function Header() {
  return(
  <Flex px={4} alignItems="center" className="header">
    <Image
      src={logo_emi} alt="Logo EMI"
      width="auto" height="70%"/>
  </Flex>
  );
};


// --- BODY ---
const Body = () => {

  // 1. State, hooks, event handling and helper functions
  const navigate = useNavigate();
  
  const handleNavigation = () => {
    navigate('/main'); 
  };

  // 2. JSX
  return(
    <Box
      className="body-layout-column"
      display="flex" flexDirection="column"
      alignItems="center" justifyContent="center">
      <Heading
        as="h1" mb="1rem"
        textAlign="center" fontFamily="title"
        fontSize="8xl" letterSpacing="10px">
        Earth Observation Toolbox
      </Heading>
      <Heading
        as="h2" mb="1em"
        textAlign="center"
        fontSize="4xl">
        Discover, fetch and use free Earth Observation data in <br/>
        a fast and unified way to enhance your mission.
      </Heading>
      <Button  fontFamily="mono" size="md" onClick={handleNavigation}>
        Launch Toolbox
      </Button>
    </Box>
  );
};


// --- EXPORT PAGE ---
const LandingPage = () => {
  return(
    <Box className="layout-column">
      <Header />
      <Body />
      <Background />
      <Copyright />
    </Box>
  );
};

export default LandingPage;